import { Directive } from 'vue'
import { mounted, updated, unmounted } from './directive'

const SnipDirective: Directive = {
  mounted,
  updated,
  unmounted
}

export default {
  install(app: any) {
    app.directive('snip', SnipDirective)
  }
}

export * from './types'
